function getViewportElement(useHtml = false) {
    const customViewport = document.querySelector('.osw-viewport');
    const defViewport = useHtml ? document.documentElement : document.body;
    return customViewport || defViewport;
}
export default getViewportElement;
//# sourceMappingURL=get-viewport-element.js.map